import axios from "axios";

import { APIGenerator } from "../../../utils/genericAPI/GenerateAPI";
import { ChangePasswordRequest, User, UserExtend, UserExtendPatch, UserPatch } from "../types/user.types";

export const BASE_URL_USER_ADMIN =
  process.env.REACT_APP_BACKEND_API_URL + "/api/v1/admin/users";
export const BASE_URL_USER_EXTEND = process.env.REACT_APP_BACKEND_API_URL + "/api/v1/user-extend";

export const userAPI = new APIGenerator<User, UserPatch, UserPatch>(BASE_URL_USER_ADMIN);
export const userExtendAPI = new APIGenerator<UserExtend, UserExtendPatch, UserExtendPatch>(BASE_URL_USER_EXTEND);
export const BASE_URL_REQUEST_PASSWORD = process.env.REACT_APP_BACKEND_API_URL +"/api/v1/reset-password-request"
export const BASE_USER_RESET_PASSWORD = process.env.REACT_APP_BACKEND_API_URL +"/api/v1/admin/users/reset-password"

export const createNewRequestPasswordAxios = (email: string) => {
  return axios.post<ChangePasswordRequest, ChangePasswordRequest>(BASE_URL_REQUEST_PASSWORD,{
    rpr_email: email
  })
}

export const resetPasswordUserAxios = (requestId: string, newPassword: string) => {
  return axios.post(BASE_USER_RESET_PASSWORD, {
    password: newPassword,
    request_id: requestId
  })
}




export default userAPI;
